export default class IntervalTimer {

    constructor(name, option, onSuccess, onError) {
        this.name = name;
        this.interval = option.interval;
        this.onSuccess = onSuccess;
        this.onError = onError;
        this.run = true;
        this.timer = 0;
    }

    start() {
        this.onSuccess().then(res => {
            if (this.run) {
                this.timer = setTimeout(() => this.start(), this.interval);
            }
        })
        .catch((error) => {
            this.onError(error);
        });
    }

    stop() {
        this.run = false;
        clearTimeout(this.timer);
    }
}
